export class StoreHistoryEntry 
{
    constructor(path:string, name:string, picture:string, timestamp:number)
    {
        this.Path=path;
        this.Name=name;
        this.Picture=picture;
        this.Timestamp=timestamp;
    }

    public Path;
    public Name;
    public Picture;
    public Timestamp;
}
